import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { NumberInput } from '../number/NumberInput';
import { FilterItem } from './FilterItem';
import { useRef } from 'react';
import { InputRange } from '../input-range/InputRange';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { DATA_FILTER_INPUT } from '../common/data';

export type NumberProps = VFFilterFieldProps<
  React.ComponentProps<typeof NumberInput> & FilterFieldProps
>;
export const FilterNumberRange = React.forwardRef<
  HTMLInputElement,
  NumberProps
>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      decimal,
      size = 6,
      filterType,
      extendedFilter,
      ...other
    },
    // @ts-ignore
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<number>) => {
            const refVaue = useRef<any[] | undefined>(undefined);
            // @ts-ignore
            refVaue.current = value;

            return (
              <InputRange centerValues>
                <NumberInput
                  {...DATA_FILTER_INPUT(`${name}-from`)}
                  _v={value}
                  className={inputClassName}
                  size={size}
                  // @ts-ignore
                  {...nother}
                  // @ts-ignore
                  name={name}
                  {...other}
                  disabled={disabled || meta.submitting}
                  decimal={decimal}
                  // @ts-ignore
                  value={value[0]}
                  onChange={(newValue: any) => {
                    // @ts-ignore
                    let resValue = [newValue, refVaue.current[1]];
                    onChange({ target: { name, value: resValue } });
                  }}
                />
                <NumberInput
                  {...DATA_FILTER_INPUT(`${name}-to`)}
                  _v={value}
                  className={inputClassName}
                  size={size}
                  // @ts-ignore
                  {...nother}
                  // @ts-ignore
                  name={name}
                  {...other}
                  disabled={disabled || meta.submitting}
                  decimal={decimal}
                  // @ts-ignore
                  value={value[1]}
                  onChange={(newValue: any) => {
                    // @ts-ignore
                    let resValue = [refVaue.current[0], newValue];
                    onChange({ target: { name, value: resValue } });
                  }}
                />
              </InputRange>
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
